import React from 'react';
import Icon from './Icon';

export default Icon(<polyline points="9,12 3,6 9,0 9,0 " />, '0 0 12 12', 'SortLeftIcon');
